import { render } from "./canceledIndexComponent.vue?vue&type=template&id=313cfb84"
import script from "./canceledIndexComponent.vue?vue&type=script&lang=js"
export * from "./canceledIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__